export const contactUsTypes = {
  CONTACTUS_LOADING: "CONTACTUS_LOADING",
  CONTACTUS_SUCCESS: "CONTACTUS_SUCCESS",
  CONTACTUS_FAILURE: "CONTACTUS_FAILURE",
};
